<template>
  <el-container class="content" style="display: block;">
  <div class="zhuyi">
      <div>关键词：XX，特殊关键词：XX，YY</div>
      <div>1.只有一个关键词的功能：商品服务，法律，裁判文书，知识问答，股票</div>
      <div>2.包含一个或俩个的功能：翻译，公交</div>
      <div>3.关键词不使用的功能：新闻，古诗，笑话</div>
      <div>4.特殊功能：定位，周边信息，导航</div>
    </div>
	<el-container class="lables">

		<el-row  class="la-list">
			<el-col :span="10" class="first">
				<el-row>
					<div class="search">
						<input type="text" v-model="searchF" @change="loadData()"/>
					</div>
				</el-row>
				<el-row class="lable-o-l lable-o-ls" v-for="(item,index) in lableFirst" :key="index">
					<div style="float: left;" class="lable-o" :class="{'choses':choseAF.indexOf(item.l_id)>-1&&item.l_id!=choses,'chosess':item.l_id==choses}"  @click="chose(item.l_id)">
          {{item.name}}
          </div>
          <div style="color: green;margin-left: 30px;float: left;" v-if="item.x1 > 0" @click="aropen(item.l_id,2,2)">开</div>
          <div style="color: darkred;margin-left: 30px;float: left;" v-if="item.x1 == 0" @click="aropen(item.l_id,1,2)">关</div>
				</el-row>
			</el-col>
			<el-col :span="4" class="centr"><img  src="../../assets/image/next.jpg"/></el-col>
			<el-col :span="10" class="two">
				<el-row>
					<div class="search">
						<input type="text"  v-model="searchT" @change="loadDataTwo()"/>
					</div>
					<div class="add" @click="add(2)" v-if="this.$store.getters.getRole == 'admins' || this.$store.getters.getRole == 'fenxi'">+ 添加</div>
          <span>{{count}}条</span>
        </el-row>
				<el-row class="lable-o-l">
					<div v-for="(item,index) in lableTwo" style="position: relative;">
					  <div class="lable-two"  :class="{'choses':choseAT.indexOf(item.id)>-1}" :key="index" @click="lableC(item.id,item.name,item.s_or_x,item.ss)">
					  {{item.name}}--<i style="color: red;">({{item.names}})</i>
					  </div>
					  <i @click="ceshi(item.id,index)"  style="position: absolute;right: -15px;bottom: 5px;">X</i>
            <span @click="aropend(item.id,item.status,2)" v-if="item.status == 1" style="position: absolute;right: -40px;bottom: 5px;color: firebrick;">开</span>
            <span @click="aropend(item.id,item.status,2)" v-if="item.status == 2" style="position: absolute;right: -40px;bottom: 5px;color: firebrick;">关</span>
					</div>
          <el-pagination
            @size-change="loadList()"
            @current-change="loadList()"
            :current-page.sync="page"
            :page-size="150000"
            background
            layout="total,prev, pager, next, jumper"
            :total="count">
          </el-pagination>
				</el-row>
			</el-col>
		</el-row>

	</el-container>
	 <el-dialog
	  title="添加"
	  :visible.sync="centerDialogVisible"
	  width="30%"
	  center>
	  <input type="text" v-focus="picFocusStatus" @input="changeInput()" class="searchTsx" v-model="addT"/>
    <select class="s_or_x" v-model='sx' value="sx">
      <option value="1">返回第一步</option>
      <option value="2">正常流程</option>
    </select>
    <select class="s_or_x" v-model='ss' value="ss">
      <option value="0">无</option>
      <option value="1">左</option>
      <option value="2">右</option>
      <option value="3">左右</option>
    </select>
	  <span slot="footer" class="dialog-footer">
		<el-button @click="centerDialogVisible = false">取 消</el-button>
		<el-button type="primary" @click="doAdd()">确 定</el-button>
	  </span>
	</el-dialog>
	<el-dialog
	  title="提示"
	  :visible.sync="dialogVisible"
	  width="30%"

	  <span>指令与<{{acp}}>重复!是否继续添加?</span>
	  <span slot="footer" class="dialog-footer">
		<el-button @click="dialogVisible = false">取 消</el-button>
		<el-button type="primary" @click="doAdds()">确 定</el-button>
	  </span>
	</el-dialog>
  </el-container>
</template>

<script>

  export default {
    data() {
      return {
        lableFirst:[],
		lableTwo:[],
		chosesT:0,
		choses:0,
		choseAF:[],
		choseAT:[],
		searchF:'',
		searchT:'',
		lable:[],
		lableEx:'',
    sx:1,
    ss:0,
		centerDialogVisible:false,
		addType:0,
		picFocusStatus:false,
		addT:'',
		dialogVisible: false,
		acp:'',
		addcf:0,
		token:window.localStorage.getItem('token'),
		userId:window.localStorage.getItem('id'),
		url:this.$store.getters.getUrl
      };
    },
	directives: {
		focus: {
		  inserted: function(el, { value }) {
			if (value) {
			  el.focus();
			}
		  }
		}
    },
    created() {
		//var cip = returnCitySN["cip"];
// 		if(this.$store.getters.getRole != 'admins'){
// 				   if(cip !='117.9.19.251' && cip !='60.27.105.250' && cip !='60.27.106.235'){
// 					   this.$router.push({ path: '/' })
// 				   }
// 		}
if(!window.localStorage.getItem('id')){
      this.$router.push({ path: '/' })
    }
       this.loadData();
	   var lett = this;
	   document.onkeydown = function(e) {
	   	var key = window.event.keyCode;
	   	if (key == 13) {
	   		lett.doAdd();
	   	}
		if (key == 17) {
			if(lett.choses > 0){
				lett.add(2);
			}

		}
	   }

    },

	methods:{
    aropend(id,o,t){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
      		id:id,
          o:o,
          t:t
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/aropend'
      })
      .then(res=>{
      	if(res.data.code == 200){
          this.loadData();
          this.loadDataTwo();


      	}else{
      		alert('修改失败')
      	}

      })
      .catch(err=>{

      });
    },
    aropen(lid,o,t){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
      		lid:lid,
          o:o,
          t:t
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/aropen'
      })
      .then(res=>{

      	if(res.data.code == 200){
           
          this.loadData();
          this.loadDataTwo();


      	}else{
      		alert('修改失败')
      	}

      })
      .catch(err=>{

      });
    },
    ceshi(id,index){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
      		id:id,
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/keyWuYiDel1Ar'
      })
      .then(res=>{
      	if(res.data.code == 200){

          this.lableTwo.splice(index,1)
          this.loadData();
      	}else{
      		alert('删除失败')
      	}

      })
      .catch(err=>{

      });
    },
		loadData(){
			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
			axiosInstance({
				method:'get',
				params:{
					name:this.searchF
				},
				url:'http://fencip.yoooooo.com/index.php/index/data/keyFirst'
			})
			.then(res=>{
				this.lableFirst = res.data;

			})
			.catch(err=>{

			});
		},
		loadDataTwo(){
			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
			axiosInstance({
				method:'get',
				params:{
					name:this.searchT,
					p_id:this.choses
				},
				url:'http://fencip.yoooooo.com/index.php/index/data/keyTwoAr'
			})
			.then(res=>{
				this.lableTwo = res.data;
        this.count = res.data.length
			})
			.catch(err=>{

			});
		},
		chose(id){
			this.choses = id;
			this.searchT = '';
			this.loadDataTwo();

		},
		lableC(id,name,type,ss){
      if (this.$store.getters.getRole == 'admins' || this.$store.getters.getRole == 'fenxi'){
        this.addT = name;
        this.chosesT = id;
        this.sx = type;
        this.ss = ss;
        this.add(1);
       }
		},
    changeInput(){
      if(this.addT.indexOf('SS')>=0){
        this.sx = 1
      }else{
        this.sx = 1
      }
    },
		add(type){
			this.addType = type;
			if(type == 2){

				this.addT = '';
        this.sx = 1
			}
			this.centerDialogVisible = true;
			this.picFocusStatus = true

		},
		msg(msg,type){
			this.$message({
			  message: msg,
			  type: type
			});
		},
		doAdds(){
			let p_id = this.choses;
			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
			axiosInstance({
				method:'post',
				params:{
					addcf:1,
					name:this.addT,
					p_id:p_id,
          sx:this.sx,
					token:this.token,
					userId:this.userId
				},
				url:'http://fencip.yoooooo.com/index.php/index/data/keyAddAr'
			})
			.then(res=>{

				if(res.data.code == 200){
					this.centerDialogVisible = false;
					this.addT = '';
          this.sx = 1
					this.dialogVisible = false
					this.acp = ''
					if(this.addType == 1){
						this.loadData();
					}else{
            this.loadData();
						this.loadDataTwo();
					}
					this.addType = 0
				}else{
					this.centerDialogVisible = false;
					this.addT = '';
          this.sx = 1
					alert('添加失败')
				}

			})
			.catch(err=>{

			});
		},
		doAdd(){
			if(this.addT == ''){
				this.msg('内容不能为空','error')
				return false;
			}
			if(this.addType == 2){
				let p_id = this.choses;
				const axiosInstance = this.$axios.create({
					headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
					withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
				});
				axiosInstance({
					method:'post',
					params:{
						addcf:0,
						name:this.addT,
						p_id:p_id,
            sx:this.sx,
            ss:this.ss,
						token:this.token,
						userId:this.userId
					},
					url:'http://fencip.yoooooo.com/index.php/index/data/keyAddAr'
				})
				.then(res=>{

					if(res.data.code == 200){
						this.centerDialogVisible = false;
						this.addT = '';
            this.sx = 1
            this.ss = 0
						if(this.addType == 1){
							this.loadData();
						}else{
              this.loadData();
							this.loadDataTwo();
						}
						this.addType = 0
					}else if(res.data.code == 202){
            alert('关键词重复')
						this.centerDialogVisible = false;
						this.dialogVisible = true
						this.acp = res.data.data
					}else{
						this.centerDialogVisible = false;
						this.addT = '';
            this.sx = 1
            this.ss = 0
						alert('添加失败')
					}

				})
				.catch(err=>{

				});
			}else{
				const axiosInstance = this.$axios.create({
					headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
					withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
				});
				axiosInstance({
					method:'post',
					params:{
						name:this.addT,
            sx:this.sx,
            ss:this.ss,
						id:this.chosesT,
						token:this.token,
						userId:this.userId
					},
					url:'http://fencip.yoooooo.com/index.php/index/data/keyChangeAr'
				})
				.then(res=>{
					if(res.data.code == 200){
						this.centerDialogVisible = false;

						this.loadDataTwo();
            this.sx = 1
            this.ss = 0
					}else{
						this.centerDialogVisible = false;
						this.addT = '';
            this.sx = 1
            this.ss = 0
						alert('添加失败')
					}

				})
				.catch(err=>{

				});
			}

		}
	}


  }
</script>

<style>

	.content{
		background: #939AA0;
		width: 100%;
		height: 100%;
	}
	.centr{
		margin-top: 30%;
	}
	.centr img{
		width: 100px;
		height: 50px;
		margin-left: 35px;
	}

	.zhuyi{
		color: red;
    margin-left: 120px;
    font-size: 20px;
	}
	.butn{
		color: #F0F8FF;
		background: #FF9400;
		margin-right: 20px;
		border-radius: 5px;
		width: 50px;
	}
	.lables{
		margin-left: 5%;
		margin-right: 5%;
		background: #fff;
		padding-bottom: 35px;
	}
	.lables .la-list{
		margin-top: 50px;
		width: 100%;
		margin-left: 20%;
		margin-right: 20%;
	}
	.first{
		border: 1px solid #c6c6c6;
		height: 850px;
		overflow-y:scroll;
	}
	.first .el-row{
		margin: 20px 10% 20px 10%;
	}
	.search input{
		width: 95%;
		height: 20px;
		margin-bottom: 10px;
		margin-left: 2%;
	}
	.add{
		text-align: center;
		width: 96%;
		background: #c6c6c6;
		height: 22px;
		line-height: 22px;
		margin-left: 2%;
	}

	.lable-o{
		width: 47%;
		text-align: center;
		background: #c6c6c6;
		height: 30px;
		line-height: 30px;
		margin-bottom: 10px;
	}
	.lable-two{

		text-align: center;
		background: #c6c6c6;

		line-height: 30px;
		margin-bottom: 10px;
	}
	.choses{
		background: #f8f1da;
	}
	.chosess{
		background: #ff9400;
	}
	.right{
		float: right;
	}
	.left{
		float: left;
	}
	.two{
		border: 1px solid #c6c6c6;
		height: 850px;
		overflow-y:scroll;
	}
	.two .el-row{
		margin: 20px 10% 20px 10%;
	}
	.searchTsx{
		width: 30%;
		margin-left: 10%;
		height: 30px;
	}
  .s_or_x{
    width: 20%;
    height: 35px;
  }
	.lable-o-ls{
		border-bottom: 1px solid #c6c6c6;
	}
</style>



// WEBPACK FOOTER //
// src/components/main/arkey.vue